module.exports = __webpack_public_path__ + "1880b1e213c07348019ce07586ec2ea3.pdf";